import {
    ADD_DOCUMENT_DISCOUNT,
    ADD_MANUAL_PROMOTION_ID,
    ADD_PLUGIN_REQUEST_SALE_DATETIME,
    ADD_PRODUCT,
    API_ERROR,
    APPLY_PROMOTIONS,
    APPLY_PROMOTIONS_PREVIEW,
    APPLY_RECEIPT_PLUGIN,
    CAFA_CONF_SET,
    CANCEL_TRANSACTION,
    CASH_IN_OUT_SUCCESS,
    CHANGE_MODE,
    CHANGE_TRANSACTION_MODE,
    CLOSE_MODAL,
    CLOSE_QCO,
    CLOSE_RIGHT_PANEL_DIALOGUE,
    CREATE_RECEIPT,
    CREATE_RECEIPT_NUMBER,
    FIND_DEFECTIVE_RETURN_PRODUCT,
    GET_NEXT_SEQUENCE_NUMBER,
    INIT_POS,
    INIT_TRANSACTION,
    OPEN_MODAL,
    POS_DAY_CLOSE_SUCCESS,
    POS_DAY_OPEN_SUCCESS,
    PRODUCT_NOT_FOUND,
    RECEIPT_DELIVERED,
    REMOVE_CUSTOMER,
    REMOVE_MANUAL_PROMOTION_ID,
    REMOVE_PRODUCT,
    REVERT_NEXT_SEQUENCE_NUMBER,
    SCANNER_DETECTED,
    SECURITY_ITEM_ADDED,
    SET_CONNECTION_HEALTH,
    SET_CUSTOMER,
    SET_CUSTOMER_AGE_VERIFIED,
    SET_ERPLY_SERVICE_ENDPOINTS,
    SET_ONE_PROMOTION_PROMO_CODE,
    SET_PENDING_DOCUMENT,
    SET_PENNIES_DONATION,
    SET_POS_DATA,
    SET_POS_DATA_FAILED,
    SET_POS_DAY_OPENED,
    SET_USER,
    SHOW_DIALOGUE,
    SHOW_SUPERVISOR_LOGON,
    START_RFID_READER,
    STOP_RFID_READER,
    TRANSACTION_SUCCESS,
    TRANSACTION_TIMEOUT_REACHED,
    TRIGGER_FIND_SCANNED_PRODUCT,
    UPDATE_PRODUCT,
    UPDATE_PRODUCTS
} from "../actionTypes";
import {
    addErrorAlert,
    addInfoAlert,
    addManualPromotionID,
    addProduct,
    addProductCodeInfo,
    addProductReturnReasonID,
    addProductRFIDSerialNumber,
    addReceiptExtraLine,
    applyPromotions,
    cancelAddUnknownItem,
    cancelTransaction as cancelTransactionAction,
    changeMode,
    changeOperationMode,
    changeTransactionMode,
    closeAdministration,
    closeAllDialogues,
    closeAllModals,
    closeDialogue,
    closeModal,
    closeQCO,
    closeRightPanelDialogue,
    findCustomerByEmail,
    findCustomerByPhone,
    findDefectiveReturnProduct,
    findProduct,
    findProducts,
    getHasSupervisorUserRights,
    getUserRights,
    initPOS,
    initTransaction,
    openLogonModal,
    openVerifyPinModal,
    productNotFound,
    removeDocumentDiscount,
    removeManualPromotionID,
    removeProduct,
    securityItemAdded,
    setCustomer,
    setCustomerCanRemove,
    setBlockScannersNormalAction,
    setErplyPromoCode,
    setLastScannedGiftCard,
    setLoading,
    setNextSequenceNumber,
    setPaybackInputDone,
    setScreenSaverNextImage,
    setTransactionUser,
    setUsedProductCustomer,
    showCallAssistance,
    showDialogue,
    showInputDialogue,
    showRightPanelDialogue,
    showSelectDialogue,
    transactionTimeoutReached,
    updateProduct,
    openModal,
    getProductsByCodeFromPim,
    saveDecathlonSCOIntegrationLog,
    bagPromptAnswered
} from "../actions";
import POSLogService from "../poslog/POSLogService";
import React from "react";
import Traceability from "../../main/Traceability";
import EnterCustomerInfo from "../../main/customerSearch/EnterCustomerInfo";
import {
    getReasonCodesByPurpose,
    getProductFromBasketByID,
    getCommercialGestureReturnReason,
    getDefectiveItemReturnReason,
    getReasonCodeByID,
    getSecurityItems,
    getReturnToStockReason,
    getProductByCode,
    getTransactionMOPLimit,
    getTransactionProductLineLimit,
    getTillNumber,
    getProductsTotalSum,
    getNumberOfDecathlonGiftCardsInBasket,
    getUnknownItemCode,
    usedProductInBasket,
    paybackEnabled,
    getProductsInBasket,
    cloneProduct,
    getInsuranceProductsInBasket,
    riskyItemInBasket
} from "../selectors";
import {HWSV, HRV, PAS} from "../../util/voucher";
import {ADD_PAYMENT, CARD_PAYMENT_FAILED, INIT_PAYMENT} from "../payment/actionTypes";
import {
    logout as paymentLogout,
    removePayment,
    setTotalSum,
    setZipCodeSurveyCounter,
    voidAllPayments
} from "../payment/actions";
import Translate from "localization/Translate";
import {getLanguages, getTranslate, localeSelected} from "localization/localizeSlice";
import {timers} from "../../util/timers";
import {
    APP_MODE_BEFORE_PAYMENT,
    APP_MODE_DONE,
    APP_MODE_SCREEN_SAVER,
    APP_STATUS_ASKED_FOR_ASSISTANCE,
    APP_STATUS_CLOSED,
    APP_STATUS_FAILED_PAYMENT,
    APP_STATUS_FREE,
    APP_STATUS_OPERATION_IN_PROGRESS,
    APP_STATUS_SECURITY_ITEM
} from "../appConstants";
import RGFD from "../payment/integrations/giftCard/main";
import GiftCardActivation from "../../main/payment/GiftCardActivation";
import {EI} from "../erplyInstaller/main";
import {ED} from "../erplyInstaller/integrations/externalDevices/main";
import Decimal from "decimal.js";
import * as uuid from "uuid";
import {getProductPackageWeight, ltrim} from "../../util/helperFunctions";
import Product from "../dto/product";
import CTR from "../../util/receiptTemplate";
import {sendStatusUpdate} from "../../communication/ManagerAppProvider";
import moment from "moment-timezone";
import {
    onPaymentMode as paybackOnPaymentMode,
    onReturnProductAdd as paybackOnReturnProductAdd,
    onTransactionModeChange as paybackOnTransactionModeChange
} from "../../integrations/payback/util";
import Customer from "../dto/customer";
import AED from "../../campaigns/employeeDiscount/employeeDiscount";
import {
    getAllCardPaymentTypesParts,
    getBlockedTransactionPaymentType,
    getPaymentReasonCode,
    giftCardPaymentIsPresent
} from "../payment/selectors";
import {setDefaultAppConf} from "../../login/configurationLoader";
import {LMS} from "../erplyInstaller/integrations/loggerms/main";
import {MCMS} from "../erplyInstaller/integrations/metricsCollector/main";
import yocuda from "../integrations/yocuda/main";
import OP from "../../campaigns/onePromotion/onePromotion";
import {PDTB} from "../../util/product";
import parseBarcode from "../rfid/BarcodeParser.min";
import {onReturnMode} from "./functions/verifiedReturn";
import {onServicePlanDetected} from "./functions/bikeServicePlan";
import FullScreenIframe from "../../integrations/feedbackApp/FullScreenIframe";
import OptIn from "../../main/customerSearch/OptIn";
import {onTransactionSuccess as penniesOnTransactionSuccess, onDayClose as penniesOnDayClose} from "../../integrations/pennies/Api";

let applyPromotionsQueue = [];
let EPCPimUpdateQueue = [];

const actionsMiddleware = store => next => action => {
    next(action);

    const state = store.getState();
    const translate = getTranslate(state);

    if(!state.rootReducer.cashierMode && state.rootReducer.view === 'app' && state.rootReducer.mode !== APP_MODE_SCREEN_SAVER && action.type !== TRANSACTION_TIMEOUT_REACHED){
        timers.setTimeout('transactionTimeout', () => {
            let currentState = store.getState();
            if(currentState.rootReducer.cashierMode){
                return;
            }
            console.log('timers timeout reached!', currentState, currentState.rootReducer.mode);
            store.dispatch(transactionTimeoutReached());
        }, window.AppConf.transactionTimeout, true);
    }

    if(action.type === TRANSACTION_TIMEOUT_REACHED && state.rootReducer.mode !== APP_MODE_SCREEN_SAVER){
        let cancelTransaction = () => {
            store.dispatch(cancelTransactionAction());
        };

        if(state.payment.payments.find(el => el.status === "started")){
            return;
        }

        if(state.rootReducer.mode === APP_MODE_DONE){
            store.dispatch(initTransaction());
            store.dispatch(changeMode(APP_MODE_SCREEN_SAVER));
            return;
        }
        let timeoutReachedDialogue = state.rootReducer.dialogues.find(el => el.title === 'timeout reached');
        if(typeof timeoutReachedDialogue !== "undefined"){
            cancelTransaction();
            store.dispatch(closeAllDialogues());
        }else{
            if(state.rootReducer.dialogues.length === 0 && state.rootReducer.modals.length === 0 && state.rootReducer.administration === false && state.rootReducer.callAssistance.length === 0){
                store.dispatch(showDialogue('timeout reached', translate('Do you want to continue with the transaction?'), 'yes', () => {}, () => {
                    cancelTransaction();
                }, 'no', false, undefined, undefined, true));
            }
        }
    }

    if(action.type === CANCEL_TRANSACTION){
        store.dispatch(voidAllPayments());
        store.dispatch(initTransaction());
        store.dispatch(changeMode(APP_MODE_SCREEN_SAVER));
        store.dispatch({type: INIT_PAYMENT});
        store.dispatch(closeRightPanelDialogue());
        if(state.rootReducer.transactionMode !== 'SALE'){
            store.dispatch(changeTransactionMode('SALE'));
        }
        if(state.rootReducer.administration !== false){
            store.dispatch(closeAdministration());
        }
        store.dispatch(closeAllModals());
    }

    const initPOSLogService = function () {
        window.posLogService = POSLogService;
        POSLogService.init(state.rootReducer.posID, state.rootReducer.warehouse.warehouseID, state.rootReducer.user.clientCode, state.rootReducer.user.employeeID);
    };

    switch (action.type) {
        case INIT_TRANSACTION: {
            if(!state.rootReducer.cashierMode){
                store.dispatch(localeSelected(getLanguages(state)[0]));
            }
            CTR.generatedReceiptNumber = {
                fromNumber: false,
                generated: false
            };
            if(window.AppConf?.enableOnePromotion ?? false){
                OP.onDocumentInit();
            }
            if(window.AppConf?.screenSaverImageSwap?.transaction){
                store.dispatch(setScreenSaverNextImage());
            }
            if(ED.available){
                ED.posEvents.initTransaction();
            }
            return true;
        }
        case SET_POS_DATA: {
            initPOSLogService();
            EI.init();
            const pos = action.payload;
            POSLogService.pointOfSaleID = pos.pointOfSaleID;
            POSLogService.warehouseID = pos.warehouseID;
            LMS.registerDevice(state.rootReducer.user.clientCode, pos.warehouseID, pos.pointOfSaleID, state.rootReducer.user.sessionKey).then((response) => {
                LMS.log("registerDevice", response);
            }, (response) => {
                LMS.log("registerDevice failed", response);
            });
            MCMS.setMonitoringParameters(state.rootReducer.user.clientCode, pos.pointOfSaleID, state.rootReducer.user.sessionKey).then((response) => {
                MCMS.log("setMonitoringParameters", response);
            }, (response) => {
                MCMS.log("setMonitoringParameters failed", response);
            });
            return true;
        }
        case SET_POS_DATA_FAILED: {
            store.dispatch(closeQCO());
            store.dispatch(addErrorAlert('Could not log in to this POS'));
            return false;
        }
        case SET_USER: {
            const user = action.payload;
            POSLogService.clientCode = user.clientCode;
            POSLogService.employeeID = user.employeeID;
            return true;
        }
        case RECEIPT_DELIVERED: {
            if(window.AppConf.enableYocuda){
                yocuda.sendReceipt(state, action.payload.deliveryType).then((response) => {
                    console.log("Yocuda receipt sent", response);
                }, (error) => {
                    console.log("Yocuda receipt not sent", error);
                    store.dispatch(addErrorAlert(error));
                });
                return;
            }
            return true;
        }
        case TRANSACTION_SUCCESS: {
            console.log('TRANSACTION_SUCCESS, send poslog!', action.payload);
            // Don't try to send while offline
            if(action.payload.invoiceID === 0){
                POSLogService.delayed = true;
            }else{
                POSLogService.sendRetailTransaction(action.payload.invoiceID, state.rootReducer.nextSequenceNumber);
                if(typeof state.payment.zipCodeSurveyCounter !== "undefined"){
                    if(state.rootReducer.erplyConf.DKTZipSurveyNonCustomer === '1' ? state.rootReducer.customer.default : true){
                        let nextZipCodeSurveyCount = state.payment.zipCodeSurveyCounter + 1;
                        if(nextZipCodeSurveyCount > state.rootReducer.erplyConf.DKTZipSurveyFrequency){
                            nextZipCodeSurveyCount = 1;
                        }
                        store.dispatch(setZipCodeSurveyCounter(nextZipCodeSurveyCount));
                    }
                }
            }
            penniesOnTransactionSuccess(state);
            return true;
        }
        case GET_NEXT_SEQUENCE_NUMBER: {
            POSLogService.getNextSequenceNumber().then((number) => {
                action.payload.success(number);
            }, action.payload.fail);
            return true;
        }
        case REVERT_NEXT_SEQUENCE_NUMBER: {
            if(state.rootReducer.nextSequenceNumber !== false){
                POSLogService.revertSequenceNumber().then(() => {
                    store.dispatch(setNextSequenceNumber(false));
                }, () => {

                });
            }
            return true;
        }
        case CREATE_RECEIPT: {
            if(window.AppConf.printDecathlonReceipt){
                CTR.createReceiptTime = moment().format("HH:mm:ss");
                CTR.onCreateReceipt(state, store.dispatch).then(action.payload.onSuccess);
            }else{
                action.payload.onSuccess(false);
            }
            return true;
        }
        case CREATE_RECEIPT_NUMBER: {
            if(window.AppConf.printDecathlonReceipt){
                let dateTime = moment();
                dateTime.tz(state.rootReducer.erplyConf.timezone);
                let date = dateTime.format("YYYY-MM-DD");
                let time = dateTime.format("HH:mm:ss");

                store.dispatch({
                    type: ADD_PLUGIN_REQUEST_SALE_DATETIME,
                    payload: {
                        date,
                        time
                    }
                });
                action.payload.onSuccess(CTR.createUniqueReceiptNumber(state.rootReducer.warehouse.code, getTillNumber(state.rootReducer.pos), date, time, state.rootReducer.nextInvoiceNo), dateTime);
            }else{
                action.payload.onSuccess(state.rootReducer.nextInvoiceNo);
            }
            return true;
        }
        case APPLY_RECEIPT_PLUGIN: {
            for (const property in action.properties){
                CTR[property] = action.properties[property];
            }
            return true
        }
        case SET_ERPLY_SERVICE_ENDPOINTS: {
            CTR.init(state);
            store.dispatch({
                type: 'CTR_INIT',
                ctr: CTR
            });
            return true;
        }
        case "localize/localeAdded": {
            CTR.appTranslate = getTranslate(state);
            return true;
        }
        case CASH_IN_OUT_SUCCESS: {
            console.log('CASH_IN_OUT_SUCCESS, send poslog!', action.payload);
            POSLogService.sendCashInOut(action.payload.transactionID, action.payload.addedUnixTime);
            return true;
        }
        case PRODUCT_NOT_FOUND: {
            if(action.payload.searchParam !== getUnknownItemCode()){
                if(action.payload.searchParam.substring(0,1) === "{"){
                    let PASVoucher = PAS.parseCode(action.payload.searchParam);
                    if(PASVoucher !== false){
                        PAS.addProduct(PASVoucher, state, store);
                        return;
                    }
                }

                if(HWSV.isWorkshopVoucher(action.payload.searchParam)) {
                    let voucher = new HWSV.voucher(action.payload.searchParam);
                    HWSV.log('voucherCode: ', action.payload.searchParam, 'voucher: ', voucher);
                    HWSV.addWorkshopProducts(
                        voucher,
                        state.rootReducer.erplyConf,
                        state.rootReducer.warehouse.code,
                        store.dispatch,
                        state.rootReducer.warehouse.warehouseID,
                        state.rootReducer.posID,
                        state.rootReducer.reasonCodes
                    );
                }else if(HRV.isReturnVoucher(action.payload.searchParam)){
                    let voucher = new HRV.voucher(action.payload.searchParam);
                    console.log('HRV voucherCode: ', action.payload.searchParam, 'voucher: ', voucher);
                    if(window.AppConf.enableSmartProductReturn){
                        HRV.smartProductReturn(store.dispatch, voucher, state.rootReducer.cashierMode).then(() => {
                            store.dispatch(findDefectiveReturnProduct(voucher), () => {
                                store.dispatch(setBlockScannersNormalAction(false));
                            });
                        });
                    }else{
                        store.dispatch(findDefectiveReturnProduct(voucher));
                    }
                }else if (RGFD.isGiftCard(action.payload.searchParam)){
                    let giftCardsInBasket = getNumberOfDecathlonGiftCardsInBasket(state.rootReducer.productsInBasket, state.rootReducer.productCategories);
                    let allowedGiftCardsInBasket = window.AppConf?.giftCardActivationLimit ?? 10;
                    let hasGiftCardMOP = giftCardPaymentIsPresent(state.payment.payments);
                    if(giftCardsInBasket >= allowedGiftCardsInBasket || hasGiftCardMOP){
                        store.dispatch(addErrorAlert("No more gift cards can be added to the basket"));
                    }else if(state.rootReducer.rightPanelDialogue !== false){
                        store.dispatch(addErrorAlert("Complete the current action before adding a gift card!"));
                    }else{
                        let giftCard = RGFD.decodeBarcode(action.payload.searchParam);
                        if(state.rootReducer.transactionMode === 'SALE'){
                            store.dispatch(showRightPanelDialogue(
                                <GiftCardActivation
                                    giftCard={giftCard}
                                />
                            ));
                        }else{
                            store.dispatch(showDialogue("Can't process gift card in return mode!", '',
                                'Ok', ()=>{}, undefined, undefined, false,
                                undefined,undefined, true));
                        }
                    }
                }else{
                    store.dispatch(showCallAssistance('unknownItem', '', true, function () {
                        setTimeout(
                            () => {
                                store.dispatch(cancelAddUnknownItem(action.payload.RFIDTag));
                            }, 100
                        );
                    }, true, (
                        <div className={'boldUppercaseText'} style={{fontSize:'1.43rem', textAlign: 'center'}}>
                            <Translate id={'Unknown item'}/>
                        </div>
                    ), undefined, undefined, action.payload));
                }
            }
            return true;
        }
        case TRIGGER_FIND_SCANNED_PRODUCT: {
            store.dispatch(setLoading(true));
            let code = action.payload.code;
            let skipOfflineSearch = action.payload?.skipOfflineSearch ?? false;
            let searchCode = PDTB.tryAllpatterns(code);
            let serialNumber = false;
            try {
                let barcode = parseBarcode(code);
                let gtinItem = barcode.parsedCodeItems.find(el => el.dataTitle === 'GTIN');
                let serialItem = barcode.parsedCodeItems.find(el => el.dataTitle === 'SERIAL');
                if(typeof gtinItem !== "undefined" && typeof serialItem !== "undefined"){
                    serialNumber = ltrim(serialItem.data, '0');
                }
            }catch (e){}

            store.dispatch(findProduct(searchCode, state.rootReducer.pos.warehouseID, state.rootReducer.pos.pointOfSaleID, false, (product) => {
                if(serialNumber !== false){
                    product.data.RFIDSerialNumber = serialNumber;
                }
                store.dispatch(setLoading(false));
                return addProduct(product);
            }, undefined, undefined, () => {
                store.dispatch(setLoading(false));
            }, undefined, undefined, serialNumber !== false ? code : false, skipOfflineSearch));

            return true;
        }
        case FIND_DEFECTIVE_RETURN_PRODUCT: {
            let voucher = action.payload.voucher;
            let vatPrice = false;
            let netPrice = false;
            if(window.AppConf.returnVoucherHasNetPrice){
                netPrice = voucher.amount;
            }else{
                vatPrice = voucher.amount;
            }

            const productNotFoundError = translate("Could not find product with code") + " " + voucher.articleCode;
            const addVoucherProductData = (product) => {
                if(product.data.active === 0 && !product.isUsedProduct()){
                    return addErrorAlert(productNotFoundError);
                }
                product.amount = voucher.articleQuantity * -1;

                if(voucher.paymentTypeCode === HRV.commercialGestureVoucherCode){
                    let returnReason = getCommercialGestureReturnReason(state.rootReducer.reasonCodes);
                    if(returnReason !== undefined){
                        product.returnReasonID = returnReason.reasonID;
                        product.returnReason = returnReason;
                        store.dispatch(addInfoAlert('Commercial Gesture Return'));
                    }else{
                        store.dispatch(addErrorAlert('Please add commercial gesture reason code to Erply!'));
                    }
                }else if(voucher.paymentTypeCode === HRV.defectiveArticleVoucherCode){
                    let returnReason = getDefectiveItemReturnReason(state.rootReducer.reasonCodes);
                    if(returnReason !== undefined){
                        product.returnReasonID = returnReason.reasonID;
                        product.returnReason = returnReason;
                        store.dispatch(addInfoAlert('Defective Item Return'));
                    }else{
                        store.dispatch(addErrorAlert('Please add defective item return reason code to Erply!'));
                    }
                }

                product.data.voucherRFIDTag = {
                    'GTIN': voucher.articleCode,
                    'SGTIN': voucher.code,
                    'SERIAL_NUMBER': voucher.getSerialNumber(),
                    'EPC': 'NULL_VALUE',
                    'ITEM_TRANSACTION_MODE':'RETURN'
                };
                if(typeof voucher.entryMethod !== "undefined"){
                    product.data.voucherRFIDTag.entryMethod = voucher.entryMethod;
                }
                if(netPrice !== false) {
                    product.setNetPrice(netPrice);
                }
                return product;
            }

            store.dispatch(setLoading(true));
            store.dispatch(findProduct(voucher.articleCode, state.rootReducer.warehouse.warehouseID, state.rootReducer.posID, vatPrice, function (product) {
                store.dispatch(setLoading(false));
                action.payload.onDone();
                return addProduct(addVoucherProductData(product));
            }, () => {
                console.log("Defective return voucher product not found!");
                action.payload.onDone();
                store.dispatch(setLoading(false));
                return productNotFound(voucher.articleCode, 'Product missing from database!', addVoucherProductData, vatPrice);
            }, undefined, undefined, undefined, false, voucher.barcode));

            return true;
        }
        case SET_ONE_PROMOTION_PROMO_CODE: {
            if(window.AppConf?.enableOnePromotion ?? false){
                OP.onPromotionCodeSet(state, store);
            }
            return true;
        }
        case UPDATE_PRODUCT: {
            if((window.AppConf?.enableOnePromotion ?? false) &&
                !action.preventApplyPromotions
            ){
                OP.onProductAdded(state, store);
            }
            break;
        }
        case ADD_PRODUCT: {
            if(window.AppConf?.enableOnePromotion ?? false){
                OP.onProductAdded(state, store);
            }

            if(Object.keys(state.rootReducer.discount).length !== 0){
                store.dispatch(removeDocumentDiscount());
            }
            let shouldCloseAdminView = true;
            let closeAdminView = function(){
                let waitingForLogin = () => {
                    if(state.rootReducer.administration === false){
                        return false;
                    }
                    return state.rootReducer.administration.user === false
                };
                if( shouldCloseAdminView &&
                    state.rootReducer.administration !== false &&
                    !waitingForLogin() &&
                    !state.rootReducer.administration.view === "addItem"
                ){
                    store.dispatch(closeAdministration());
                }
            };
            let product = cloneProduct(state.rootReducer.productsInBasket[state.rootReducer.productsInBasket.length - 1]);
            console.log('MIDDLEWARE ACTION: ADD_PRODUCT', product, product.data.RFIDTag);

            if(state.rootReducer.invoice !== false){
                store.dispatch(addErrorAlert('Can\'t add products to this document!'));
                store.dispatch(removeProduct(product));
                return;
            }
            if(action.pendingDocument !== false){
                return;
            }
            if(state.rootReducer.returnBaseDocument !== false){
                store.dispatch(addErrorAlert('Can\'t add products to this document!'));
                store.dispatch(removeProduct(product));
                return;
            }

            if(product.isUsedProduct()){
                let usedProductInBasket = state.rootReducer.productsInBasket.filter(el => el.data.productID === product.data.productID);
                if(usedProductInBasket.length > 1){
                    store.dispatch(addErrorAlert('The product is already in the basket!'));
                    store.dispatch(removeProduct(product));
                    return;
                }
            }

            if(state.rootReducer.transactionMode === 'RETURN' && typeof state.rootReducer.payback.referenceReceipt !== "undefined"){
                let paybackRemoveProduct = paybackOnReturnProductAdd(product, store.dispatch, state);
                if(paybackRemoveProduct){
                    store.dispatch(removeProduct(product));
                    return;
                }
            }else{
                if(window.AppConf.enableVerifiedReturn && state.rootReducer.transactionMode === 'RETURN' && state.rootReducer.returnBasePOSLog !== false){
                    store.dispatch(addErrorAlert('Can\'t add products to the return transaction'));
                    store.dispatch(removeProduct(product));
                    return;
                }
            }

            if(ED.available){
                if(ED.scaleConfigured){
                    scalePrompt(product, store);
                }
                ED.posEvents.addProduct(product, state);
            }

            let isReturnedProduct = product.returnReason !== undefined && product.returnReason.purpose === 'RETURN';
            if((state.rootReducer.transactionMode === 'RETURN' || product.amount < 0) && !isReturnedProduct){
                if(product.isReturnable()){
                    if(process.env.REACT_APP_ERPLY_MODE !== "1" && !window.AppConf.customReturnReasonCodes){
                        let returnReason = getReturnToStockReason(state.rootReducer.reasonCodes);
                        if(returnReason !== undefined){
                            store.dispatch(addProductReturnReasonID(product.lineNumber, returnReason));
                        }else{
                            store.dispatch(addErrorAlert('Please add return to stock reason code to Erply!'));
                        }
                    }else{
                        let reasonCodeOptions = getReasonCodesByPurpose(state.rootReducer.reasonCodes, 'RETURN').reduce((acc, reasonCode) => {
                            acc.push({
                                name: reasonCode.name,
                                value: reasonCode.reasonID
                            });
                            return acc;
                        }, []);

                        store.dispatch(showSelectDialogue('Return reason', reasonCodeOptions, (reasonID, reason) => {
                            let reasonCode = getReasonCodeByID(state.rootReducer.reasonCodes, reasonID);
                            if(reasonCode === undefined){
                                reasonCode = {reasonID, name: reason};
                            }
                            store.dispatch(addProductReturnReasonID(product.lineNumber, reasonCode));
                        }, e => {}, false, undefined, undefined, product.data.code + ' ' + product.data.name));
                    }
                }else{
                    store.dispatch(showDialogue('Item is not returnable!', '', 'Ok', function () {
                        store.dispatch(removeProduct(product));
                    }, undefined, undefined, false, undefined, undefined, true));
                    closeAdminView();
                    return true;
                }
            }

            if(product.isBlocked()){
                handleBlockedItem(store, state, product, closeAdminView);
            }

            if(state.rootReducer.transactionMode === 'SALE' && product.isSecurityItem()){
                handleSecurityItem(store, state, product);
            }

            if(state.rootReducer.transactionMode === 'SALE' && product.hasSecurityUKPlug()){
                const showSecurityUKPlugErrorMessage = () => {
                    store.dispatch(addErrorAlert("User has no right to perform this action!"));
                };
                const showSecurityUKPlugMessage = () => {
                    store.dispatch(showDialogue( 'Attention, UK plug detected!', "", "Proceed", () => {
                        store.dispatch(openVerifyPinModal(store.dispatch, state.rootReducer.user.clientCode, (user) => {
                            if (!window.AppConf.selfValidateSupervisor && user.userID === state.rootReducer.user.userID) {
                                showSecurityUKPlugMessage();
                                showSecurityUKPlugErrorMessage();
                            } else {
                                store.dispatch(getHasSupervisorUserRights(user.userID, state.rootReducer.posID, (hasSupervisorRights) => {
                                    if(!hasSupervisorRights){
                                        showSecurityUKPlugErrorMessage();
                                    }
                                    return {
                                        type: 'USER_RIGHTS_SUCCESS'
                                    }
                                }, () => {
                                    return addErrorAlert('Could not get user right records, please try again!');
                                }));
                            }
                        }, () => {}, () => {
                            showSecurityUKPlugMessage();
                        }));
                    }, () => {
                        store.dispatch(removeProduct(product));
                    }, "Cancel", false, undefined, undefined, true));
                }
                showSecurityUKPlugMessage();
            }

            if(state.rootReducer.transactionMode === 'SALE' && product.isBikeServicePlan()){
                onServicePlanDetected(store, state);
            }

            if(product.data.code === getUnknownItemCode() || product.data.code2 === getUnknownItemCode()){
                shouldCloseAdminView = false;
            }

            if(state.rootReducer.transactionMode === 'SALE' && product.isRiskyItem()){
                riskyItemPrompt(store, state);
            }

            if(product.hasContainer){
                store.dispatch(
                    findProducts(
                        {
                            productID: product.data.containerID
                        },
                        state.rootReducer.warehouse.warehouseID,
                        state.rootReducer.pos.pointOfSaleID,
                        result => {
                            let productDTO = new Product(result[0].name, result[0].priceListPrice, result[0].priceListPriceWithVat, product.amount, result[0]);
                            productDTO.containerForProductLine = product.lineNumber;
                            productDTO._isContainer = true;
                            return addProduct(productDTO);
                        }, result => {
                            return addErrorAlert('Could not add container product!');
                        }
                    )
                );
            }

            if(state.rootReducer.productsInBasket.length > getTransactionProductLineLimit()){
                store.dispatch(showDialogue('Can\'t add more products to the basket!', '', 'Ok', function () {
                    store.dispatch(removeProduct(product));
                }, undefined, undefined, false, undefined, undefined, true));
            }

            if( window.AppConf.usedProductConfirm === true &&
                process.env.REACT_APP_ERPLY_MODE !== "1" &&
                state.rootReducer.transactionMode === 'SALE' &&
                (product.data.seriesName === 'DKT:SecondHand' || product.data.seriesName === 'DKT:BuyBack')
            ){
                store.dispatch(showDialogue('You are adding a used product into your basket',
                    `<p style="text-align: center">${product.data.name}</p><p>${translate("I declare that I have read the description of the used goods and I accept its condition")}</p>`,
                    'I accept', function(){}, function () {
                        store.dispatch(removeProduct(product));
                    }, "decline", false, undefined, undefined, true));
            }

            if( typeof window.AppConf.importedItemInfo !== "undefined" &&
                window.AppConf.importedItemInfo.receiptText !== "" &&
                process.env.REACT_APP_ERPLY_MODE !== "1" &&
                (product.data.seriesName === 'DKT:PassionBrand' || product.data.seriesName === 'DKT:WorkshopVoucher')
            ){
                store.dispatch(addProductCodeInfo(product.lineNumber, window.AppConf.importedItemInfo.productText));
                if(typeof state.rootReducer.receiptExtraLines.find(line => {
                    if(typeof line !== "string"){
                        return false;
                    }
                    return line.indexOf(window.AppConf.importedItemInfo.receiptText) !== -1;
                }) === "undefined"){
                    store.dispatch(addReceiptExtraLine(window.AppConf.importedItemInfo.receiptText));
                }
            }

            if((typeof product.data.RFIDTag === "undefined" || product.data.RFIDTag.SERIAL_NUMBER === "NULL_VALUE") &&
                typeof product.data.RFIDSerialNumber === "undefined" &&
                typeof product.data.voucherRFIDTag === "undefined" &&
                Math.abs(product.amount) === 1 &&
                product.needsSerialNumber()
            ){
                let insertSerialNumberID = "insertSerialNumber_" + product.lineNumber;
                store.dispatch(showInputDialogue('Insert serial number!', '', '', function (serialNumber) {
                    store.dispatch(addProductRFIDSerialNumber(product.lineNumber, serialNumber));
                }, undefined, false, true, undefined, insertSerialNumberID, undefined, undefined));
            }

            closeAdminView();
            break;
        }
        case REMOVE_PRODUCT: {
            if(window.AppConf?.enableOnePromotion ?? false){
                OP.onProductAdded(state, store);
            }
            let product = action.payload;
            if(product.isRiskyItem()){
                if(store.getState().rootReducer.rightPanelDialogue !== false){
                    let currentRiskyProducts = getProductFromBasketByID(store.getState().rootReducer.productsInBasket, product.data.productID);
                    if(currentRiskyProducts.length === 0){
                        store.dispatch(closeRightPanelDialogue());
                    }
                }
            }
            /*if(product._isContainer){
                if(typeof product.containerForProduct !== "undefined"){
                    store.dispatch(removeProduct(product.containerForProduct));
                }
            }else if(product.hasContainer){
                let containerProduct = state.rootReducer.productsInBasket.find(el => el.containerForProduct === product);
                if(typeof containerProduct !== "undefined"){
                    store.dispatch(removeProduct(containerProduct));
                }
            }*/
            if(ED.available){
                ED.posEvents.removeProduct(product, state);
            }
            break;
        }
        case API_ERROR: {
            if(action.displayError !== false){
                store.dispatch(addErrorAlert(action.payload));
            }
            return true;
        }
        case SET_POS_DAY_OPENED: {
            sendStatusUpdate(APP_STATUS_FREE);
            return true;
        }
        case CHANGE_TRANSACTION_MODE: {
            if(paybackEnabled()){
                paybackOnTransactionModeChange(store.dispatch, state);
            }else if(window.AppConf?.enableVerifiedReturn ?? false){
                if(state.rootReducer.transactionMode === "RETURN"){
                    onReturnMode(store, state);
                }
            }
            return true;
        }
        case CHANGE_MODE: {
            if(state.rootReducer.mode === 'screenSaver'){
                sendStatusUpdate(APP_STATUS_FREE);
            }else if(state.rootReducer.mode === 'scan'){
                sendStatusUpdate(APP_STATUS_OPERATION_IN_PROGRESS);
                if(paybackEnabled()){
                    if(state.rootReducer.transactionMode === "SALE"){
                        store.dispatch(setPaybackInputDone(false));
                    }
                }
            }else if(action.payload.mode === 'payment'){
                addBagPrompt(store, state);
                if(window.AppConf.enableEPCProductApiSearchOnPayment){
                    handleEPCProductApiSearch(store);
                }
                if(process.env.REACT_APP_ERPLY_MODE !== "1"){
                    usedProductPrompt(store, state);
                    if(window?.AppConf?.insuranceProductPrompt ?? false){
                        insuranceProductPrompt(store, state);
                    }
                }
                if(paybackEnabled()){
                    CTR.generatedReceiptNumber = {
                        fromNumber: false,
                        generated: false
                    };
                    paybackOnPaymentMode(store.dispatch, state);

                    if(state.rootReducer.payback.customer !== false){
                        let customer = state.rootReducer.customer === false ? new Customer() : Object.assign({}, state.rootReducer.customer);
                        customer.localRequirements = {
                            name: "PaybackAccount",
                            value: state.rootReducer.payback.customer
                        }
                        store.dispatch(setCustomer(customer));
                    }
                }
            }

            return true;
        }
        case OPEN_MODAL: {
            if(action.payload.type === 'logon'){
                sendStatusUpdate(APP_STATUS_ASKED_FOR_ASSISTANCE);
            }
            return true;
        }
        case CLOSE_MODAL: {
            if(state.rootReducer.mode === 'scan'){
                sendStatusUpdate(APP_STATUS_OPERATION_IN_PROGRESS);
            }
            return true;
        }
        case SECURITY_ITEM_ADDED: {
            sendStatusUpdate(APP_STATUS_SECURITY_ITEM);
            return true;
        }
        case SET_CUSTOMER_AGE_VERIFIED: {
            sendStatusUpdate(APP_STATUS_OPERATION_IN_PROGRESS);
            return true;
        }
        case CARD_PAYMENT_FAILED: {
            sendStatusUpdate(APP_STATUS_FAILED_PAYMENT);
            return true;
        }
        /*case CHANGE_MODE: {
            if(state.rootReducer.mode === 'payment' && state.rootReducer.transactionMode === 'RETURN'){
                store.dispatch(changeTransactionMode('SALE'));
            }
            return true;
        }*/
        case POS_DAY_OPEN_SUCCESS: {
            let employeeID = false;
            if(state.rootReducer.transactionUser !== false){
                employeeID = state.rootReducer.transactionUser.employeeID;
            }
            POSLogService.POSEvents.afterOpenDay(action.dayID, action.openedSum, action.openedUnixTime, employeeID);
            return true;
        }
        case POS_DAY_CLOSE_SUCCESS: {
            let employeeID = false;
            if(state.rootReducer.transactionUser !== false){
                employeeID = state.rootReducer.transactionUser.employeeID;
            }
            POSLogService.POSEvents.afterCloseDay(state.rootReducer.posDayID, employeeID);
            store.dispatch(paymentLogout());
            penniesOnDayClose(state);
            return true;
        }
        case ADD_PAYMENT: {
            if(state.payment.payments.length + 1 === getTransactionMOPLimit()){
                store.dispatch(showDialogue('You can only add one more payment method!', '', 'Ok', function () {

                }, undefined, undefined, false, undefined, undefined, true));
            }
            let paymentReasonCode = getPaymentReasonCode(action.payload, state.payment.paymentTypes);
            if(paymentReasonCode !== false){
                let blockedType = getBlockedTransactionPaymentType(state.payment.blockedTransactionPaymentTypes, paymentReasonCode);
                if(blockedType !== false){
                    blockedType.onBlock(state).then(() => {
                        store.dispatch(removePayment(action.payload));
                    }, () => {});
                }
            }
            if(ED.available){
                ED.posEvents.addPayment(action.payload, state);
            }
            return true;
        }
        case SCANNER_DETECTED: {
            if(state.rootReducer.mode === 'addGiftCard'){
                store.dispatch(setLastScannedGiftCard(action.payload));
            }
            return true;
        }
        case CLOSE_QCO: {
            if(window.AppConf.feedbackApp.employee.enabled){
                const feedbackModalID = uuid.v4();
                store.dispatch(openModal({
                    content: <FullScreenIframe
                        conf={window.AppConf.feedbackApp}
                        type={"employee"}
                        onDone={() => {
                            store.dispatch(closeModal(feedbackModalID));
                        }}
                    />,
                    id: feedbackModalID,
                    className: "Administration",
                    canClose: false
                }));
            }
            timers.removeTimeout('userSessionUpdate');
            for(let interval of state.rootReducer.intervals){
                clearInterval(interval);
            }
            if(!window.AppConf?.decathlonSSO){
                setTimeout(() => {
                    store.dispatch({
                        type: INIT_POS
                    });
                },100);
            }
            sendStatusUpdate(APP_STATUS_CLOSED);
            setDefaultAppConf();
            return true;
        }
        case SHOW_SUPERVISOR_LOGON: {
            store.dispatch(openLogonModal(action.payload.title, action.payload.afterLogonAction, action.payload.canClose, true, action.payload.onClose));
            return true;
        }
        case CAFA_CONF_SET: {
            if(window.AppConf?.enableCardTypeSelectForManualCard ?? false){
                let manualCardMOP = (window.AppConf?.paymentTypes?.manualInput ?? []).find(el => (el.type === 'manualCard' || el.reasonCode === '98'));
                if(typeof manualCardMOP !== "undefined"){
                    let cardPaymentTypes = getAllCardPaymentTypesParts(state.rootReducer.erplyConf);
                    let cardPaymentTypesFilter = window.AppConf?.cardTypesForManualCard ?? [];
                    console.log({cardPaymentTypes});
                    let options = ["<option value=''></option>"];
                    for(let cardPaymentType in cardPaymentTypes){
                        if(cardPaymentTypesFilter.length === 0 || cardPaymentTypesFilter.indexOf(cardPaymentType) !== -1){
                            options.push(`<option value="${cardPaymentType}">${translate(cardPaymentTypes[cardPaymentType].name)}</option>`);
                        }
                    }
                    manualCardMOP.extraHtml = `<div style="margin: 3.57rem 7.14rem">
                        <h2>${translate("Choose card type")}</h2>
                        <select id="manualCardPaymentCardType" class="underlineInput selectInput">
                        ${options.join("")}
                        </select>
                    </div>`;

                    manualCardMOP.addExtraInfo = (payment) => {
                        return new Promise((resolve, reject) => {
                            let cardType = document.getElementById('manualCardPaymentCardType').value;
                            if(cardType !== ""){
                                payment.cardType = cardType;
                                resolve(payment);
                            }else{
                                store.dispatch(addErrorAlert("Choose the card type!"));
                                reject();
                            }
                        });
                    }
                }
            }
            return true;
        }
        case CLOSE_RIGHT_PANEL_DIALOGUE: {
            if(!riskyItemPromptHandled){
                if(riskyItemInBasket(state)){
                    riskyItemPrompt(store, state);
                }else{
                    riskyItemPromptHandled = true;
                    store.dispatch({type: START_RFID_READER});
                    store.dispatch(setBlockScannersNormalAction(false));
                }
            }
            return true;
        }
        case SET_PENNIES_DONATION: {
            if(!state.rootReducer.cashierMode){
                let count = localStorage.getItem('penniesDonationAsked');
                localStorage.setItem('penniesDonationAsked', Number(count) + 1);
            }
            return true;
        }
        default: {}
    }

    if (
        (
            action.type === APPLY_PROMOTIONS ||
            action.type === ADD_PRODUCT ||
            action.type === REMOVE_PRODUCT ||
            (action.type === UPDATE_PRODUCT && !action.preventApplyPromotions) ||
            action.type === ADD_DOCUMENT_DISCOUNT ||
            action.type === SET_CUSTOMER ||
            action.type === REMOVE_CUSTOMER ||
            action.type === ADD_MANUAL_PROMOTION_ID ||
            action.type === REMOVE_MANUAL_PROMOTION_ID ||
            action.type === SET_PENDING_DOCUMENT ||
            (action.type === CHANGE_MODE && action.payload.mode === 'payment')
        )
        && state.rootReducer.productsInBasket.length > 0
    ) {
        applyPromotionsQueue.push(1);
        setTimeout(() => {
            applyPromotionsQueue.pop();
            if(applyPromotionsQueue.length === 0){
                store.dispatch(setLoading(true));
                handleBeforeApplyPromotionsEvents(action).finally(() => {
                    let currentState = store.getState();
                    store.dispatch(applyPromotions(getProductsInBasket(currentState), currentState.rootReducer.pos, currentState.rootReducer.customer, currentState.rootReducer.erplyConf.default_client_idDat, () => {
                        store.dispatch(setLoading(false));
                    }, currentState.rootReducer.manualPromotionIDs, currentState.rootReducer.erplyPromoCode));
                });
            }
        }, 200);
    }
    const handleBeforeApplyPromotionsEvents = (action, events = false) => {
        return new Promise((resolve, reject) => {
            let currentState = store.getState();
            if(events === false){
                events = Object.values(state.rootReducer.beforeApplyPromotionsEvents);
            }
            if(events.length === 0){
                resolve();
                return;
            }
            let event = events.pop();
            event(currentState, action).catch(()=>{}).finally(() => {
                handleBeforeApplyPromotionsEvents(action, events).then(resolve, reject);
            })
        });
    }

    if (state.rootReducer.productsInBasket.length > 0 && action.type === APPLY_PROMOTIONS_PREVIEW){
        OP.addPromotion(store, true, false, {
            customer: action.payload.customer
        }).then((products) => {
            let currentState = store.getState();
            store.dispatch(applyPromotions(
                products,
                currentState.rootReducer.pos,
                action.payload.customer,
                currentState.rootReducer.erplyConf.default_client_idDat,
                (result) => {
                    action.payload.onDone(result);
                },
                currentState.rootReducer.manualPromotionIDs,
                currentState.rootReducer.erplyPromoCode,
                false
            ));
        }, (error) => {
            console.log("Failed to get one promotion quote", error);
            action.payload.onDone();
        });
    }

    if(action.type === UPDATE_PRODUCTS){
        if(state.rootReducer.mode === 'payment'){
            const totalSum = getProductsTotalSum(state.rootReducer.productsInBasket);
            store.dispatch(setTotalSum(totalSum));
        }
        if(ED.available){
            ED.posEvents.updateProducts(action.payload, state);
        }
    }

    if(action.type === SET_CUSTOMER){
        console.log("customer set action", action.payload);
        if(process.env.REACT_APP_ERPLY_MODE !== "1"){
            AED.onEmployeeSet(action.payload, state, store);
        }
        if(window.AppConf?.enableErplyPromoCode){
            if(state.rootReducer.erplyPromoCode !== false && action.payload !== false){
                if(state.rootReducer.manualPromotionIDs.indexOf(state.rootReducer.erplyPromoCode.campaignID) === -1){
                    store.dispatch(addManualPromotionID(state.rootReducer.erplyPromoCode.campaignID));
                    store.dispatch(setErplyPromoCode(state.rootReducer.erplyPromoCode.code, "applied", "applied", state.rootReducer.erplyPromoCode.campaignID, true));
                }
            }
        }
        if(window.AppConf?.customerOptInOnIdentification && action.payload !== false && !action.payload.isDecathlonEmployee()){
            if(window.AppConf?.showOptInIncentives){
                if(action.payload.marketingConsent === "blank" || action.payload.marketingConsent === "false"){
                    store.dispatch({
                        type: APPLY_PROMOTIONS_PREVIEW,
                        payload: {
                            customer: state.rootReducer.decathlonVipCustomer,
                            onDone: (result) => {
                                console.log("Apply promotions preview", result);
                                store.dispatch(openModal({
                                    id: "marketingConsentModal",
                                    content: <OptIn
                                        onDone={() => {
                                            store.dispatch(closeModal("marketingConsentModal"));
                                        }}
                                        vipBasketTotal={result.total}
                                    />,
                                    className: "Administration",
                                    canClose: false,
                                    onClose: ()=>{}
                                }));
                            }
                        }
                    });
                }
            }else{
                if(action.payload.marketingConsent === "blank"){
                    store.dispatch(openModal({
                        id: "marketingConsentModal",
                        content: <OptIn onDone={() => {
                            store.dispatch(closeModal("marketingConsentModal"));
                        }}/>,
                        className: "Administration",
                        canClose: false,
                        onClose: ()=>{}
                    }));
                }
            }
        }
    }

    if(action.type === REMOVE_CUSTOMER){
        if(window.AppConf.erplyMode !== true){
            AED.onEmployeeRemove(state, store);
        }
        if(window.AppConf?.enableErplyPromoCode){
            if(state.rootReducer.erplyPromoCode !== false && state.rootReducer.erplyPromoCode.customerIdentified){
                if(state.rootReducer.manualPromotionIDs.indexOf(state.rootReducer.erplyPromoCode.campaignID) !== -1){
                    store.dispatch(removeManualPromotionID(state.rootReducer.erplyPromoCode.campaignID));
                    store.dispatch(setErplyPromoCode(state.rootReducer.erplyPromoCode.code, "error", "Applies only for identified customers", state.rootReducer.erplyPromoCode.campaignID, true));
                }
            }
        }
        if((window?.AppConf?.insuranceProductPrompt ?? false) && state.rootReducer.mode === "payment"){
            insuranceProductPrompt(store, state);
        }
    }

    if(action.type === SET_CONNECTION_HEALTH && state.rootReducer.view === 'app'){
        if(action.payload === false){
            const showNoConnectionDialogue = () => {
                store.dispatch({
                    type: SHOW_DIALOGUE,
                    payload: {
                        id: "noConnection",
                        title: 'Alert!!',
                        message: `
                      <p style="font-size: 1.86rem; margin-top: 10rem;">${translate('Connection failed. Please launch degraded mode to continue using the POS.')}</p>
                      <p style="font-size: 1.43rem;">${translate('Note: Some functionalities might be limited or not available in this mode.')}</p>
                    `,
                        confirmText: 'Continue',
                        onConfirm: () => {
                            store.dispatch(openLogonModal('Logon to confirm offline mode!', (data) => {
                                if(state.rootReducer.operationMode === 'lite'){
                                    let updateOperationMode = () => {
                                        let currentState = store.getState();
                                        if(currentState.rootReducer.mode === "scan" || currentState.rootReducer.mode === "screenSaver"){
                                            store.dispatch(changeOperationMode('cashier'));
                                        }else{
                                            setTimeout(() => {
                                                updateOperationMode();
                                            }, 4000);
                                        }
                                    }
                                    updateOperationMode();
                                }
                            }, true, undefined, () => {
                                if(!store.getState().rootReducer.connectionHealth){
                                    showNoConnectionDialogue();
                                }
                            }));
                        },
                        onCancel: () => {
                            store.dispatch(closeQCO());
                        },
                        cancelText: 'Close till',
                        canClose: false,
                        messageClass:''
                    }
                });
            }
            showNoConnectionDialogue();
        }else{
            if(typeof state.rootReducer.dialogues.find(el => el.id === 'noConnection') !== "undefined"){
                store.dispatch(closeDialogue('noConnection'));
            }else{
                let openedOfflineLogonModal = state.rootReducer.modals.find(el => el.type === 'logon');
                if(typeof openedOfflineLogonModal !== "undefined"){
                    store.dispatch(closeModal(openedOfflineLogonModal.id));
                    if(typeof openedOfflineLogonModal.onClose !== "undefined"){
                        openedOfflineLogonModal.onClose();
                    }
                }
                store.dispatch({
                    type: SHOW_DIALOGUE,
                    payload: {
                        id: uuid.v4(),
                        title: 'Alert!!',
                        message: `<p style="font-size: 1.86rem; margin-top: 10rem;">${translate('POS Connection restored.')}</p>`,
                        confirmText: 'Continue',
                        onConfirm: () => {
                            if(state.rootReducer.offlineLogin){
                                store.dispatch(initPOS());
                            }
                        },
                        onCancel: () => {
                            store.dispatch(closeQCO());
                        },
                        cancelText: 'Close till',
                        canClose: false,
                        messageClass:''
                    }
                });
            }
        }
    }

    if(window.AppConf.enableEPCProductApiSearch){
        if(action.type === ADD_PRODUCT){
            EPCPimUpdateQueue.push(1);
            setTimeout(() => {
                EPCPimUpdateQueue.pop();
                if (EPCPimUpdateQueue.length === 0) {
                    handleEPCProductApiSearch(store);
                }
            }, 200);
        }
    }
};


const addBagPrompt = (store, state) => {
    if(window.AppConf.addBagPrompt && window.AppConf.bagItemCode){
        const bagInBasket = getProductByCode(state.rootReducer.productsInBasket, window.AppConf.bagItemCode);
        console.log({bagInBasket});
        if(typeof bagInBasket !== "undefined") return true;

        store.dispatch(showDialogue('Do you need a bag?','', 'Yes', () => {
            store.dispatch(bagPromptAnswered(true));
            const askBagAmount = () => {
                store.dispatch(showInputDialogue('How many bags do you need?', '', '', (bagAmount) => {
                    let parsedAmount = parseInt(bagAmount);
                    if(isNaN(parsedAmount)){
                        store.dispatch(addErrorAlert('Please enter number'));
                        askBagAmount();
                        return;
                    }
                    if(parsedAmount < 1){
                        return;
                    }
                    store.dispatch(setLoading(true));
                    store.dispatch(findProduct(window.AppConf.bagItemCode, state.rootReducer.pos.warehouseID, state.rootReducer.pos.pointOfSaleID, false, (product) => {
                        product.amount = parseInt(bagAmount);
                        return addProduct(product);
                    }, undefined, undefined, () => {
                        store.dispatch(setLoading(false));
                    }));
                }, () => {}, true, true));
            }
            setTimeout(askBagAmount,1);
        }, () => {
            store.dispatch(bagPromptAnswered(false));
        },'No', false, "addBagPrompt", undefined, true));
    }
};

const usedProductPrompt = (store, state) => {
    if(state.rootReducer.erplyConf.country !== "BE" && usedProductInBasket(getProductsInBasket(state))){
        store.dispatch({
            type: 'SHOW_DIALOGUE',
            payload: {
                title: 'Enter customer info',
                inputFields: [
                    {id: "customerName", name: "Name"},
                    {id: "customerAddress", name: "Address"},
                    {id: "customerCity", name: "City"}
                ],
                onDone: (inputValues, close, setValidationErrors) => {
                    console.log('Used product customer info', inputValues);
                    store.dispatch(setUsedProductCustomer(inputValues));
                    close();
                },
                onClose: () => {
                },
                onChange: () => {
                },
                canClose: true,
                closeOnDone: false,
                multipleInputDialogue: true,
                keyboardLayout: 'letters'
            }
        });
    }
}

const insuranceProductPrompt = (store, state) => {
    let customer = state.rootReducer.customer;
    if(customer !== false && !customer.default){
        return;
    }

    let insuranceProducts = getInsuranceProductsInBasket(state.rootReducer.productsInBasket);
    if(insuranceProducts.length > 0){
        store.dispatch(showDialogue(
            "Required information",
            "insuranceMessage",
            "Identify with my Decathlon account",
            () => {
                if(customer !== false && customer.default){
                    store.dispatch(setCustomer(false));
                }
                store.dispatch((changeMode(APP_MODE_BEFORE_PAYMENT)));
            },
            () => {
                if(state.rootReducer.productsInBasket.length === insuranceProducts.length){
                    store.dispatch(cancelTransactionAction());
                    return;
                }
                insuranceProducts.forEach((product) => {
                    store.dispatch(removeProduct(product));
                });
            },
            "Refuse and remove the insurance",
            false
        ));
        setTimeout(() => {
            let currentState = store.getState();
            if(typeof currentState.rootReducer.dialogues.find(el => el.id === "addBagPrompt") !== "undefined"){
                store.dispatch(closeDialogue("addBagPrompt"));
            }
        }, 1);
    }
}

const scalePrompt = (product, store) => {
    console.log('ED: ADD_PRODUCT', {product});
    if(product.data.unitName === 'kg' && product.barcodeWeight !== true && product.barcodePrice !== true){
        let putProductOnScaleDialogueID = uuid.v4();
        let weighingDialogueID = uuid.v4();
        let cancelLoop = false;

        let scaleLoop = (lastWeight=false) => {
            if(cancelLoop){
                return true;
            }
            ED.scaleWeight((response) => {
                ED.log('ScaleWeight response', response);
                if(response.statusMessage === 'success'){
                    let weight = parseFloat(response.data.weight.trim());
                    if(weight !== false && weight !== 0 && weight === lastWeight){
                        let packageWeight = getProductPackageWeight(product.data);
                        if(typeof packageWeight !== "undefined"){
                            weight = (new Decimal(weight)).minus(new Decimal(packageWeight)).toDecimalPlaces(4).toNumber();
                        }
                        if(weight <= 0){
                            store.dispatch(showDialogue(
                                'Please use a proper container!',
                                '',
                                'Ok',
                                () => {
                                    scaleLoop();
                                },
                                () => {
                                    cancelLoop = true;
                                    store.dispatch(removeProduct(product));
                                },
                                undefined,
                                true,
                                weighingDialogueID,
                                undefined,
                                true
                            ));
                        }else{
                            let currentProduct = cloneProduct(store.getState().rootReducer.productsInBasket.find(basketProduct => basketProduct.lineNumber === product.lineNumber));
                            if(typeof currentProduct !== "undefined"){
                                currentProduct.setAmount(weight);
                                store.dispatch(updateProduct(currentProduct));
                            }
                            store.dispatch(closeDialogue(weighingDialogueID));
                        }
                    }else{
                        if(weight !== 0){
                            store.dispatch(closeDialogue(putProductOnScaleDialogueID));
                            store.dispatch(showDialogue(
                                'Weighing',
                                '',
                                undefined,
                                undefined,
                                () => {
                                    cancelLoop = true;
                                    store.dispatch(removeProduct(product));
                                },
                                undefined,
                                true,
                                weighingDialogueID,
                                undefined,
                                true
                            ));
                        }
                        setTimeout(() => {
                            scaleLoop(weight);
                        }, 300);
                    }
                }else{
                    store.dispatch(addErrorAlert(response.statusMessage));
                    store.dispatch(removeProduct(product));
                    store.dispatch(closeDialogue(weighingDialogueID));
                }
            });
        };


        store.dispatch(showDialogue(
            'Put product on the scale',
            '',
            undefined,
            undefined,
            () => {
                cancelLoop = true;
                store.dispatch(removeProduct(product));
            },
            undefined,
            true,
            putProductOnScaleDialogueID,
            undefined,
            true
        ));
        scaleLoop();
    }
}

let riskyItemPromptHandled = true;
const riskyItemPrompt = (store, state) => {
    if(state.rootReducer.customer === false){
        riskyItemPromptHandled = false;
        store.dispatch({type: STOP_RFID_READER});
        store.dispatch(setBlockScannersNormalAction(true));
        let dialogue = (
            <Traceability
                enterDetails={() => {
                    store.dispatch(showRightPanelDialogue((
                        <EnterCustomerInfo
                            onDone={(customerInfo) => {
                                if(typeof customerInfo.email !== "undefined"){
                                    store.dispatch(setLoading(true));
                                    store.dispatch(findCustomerByEmail(customerInfo.email, () => {
                                        store.dispatch(setLoading(false));
                                    }, () => {
                                        store.dispatch(setLoading(false));
                                    }, false));
                                }else if(typeof customerInfo.phone !== "undefined"){
                                    store.dispatch(setLoading(true));
                                    store.dispatch(findCustomerByPhone(customerInfo.phone, state.rootReducer.erplyConf.DKTCountryCode, () => {
                                        store.dispatch(setLoading(false));
                                    }, () => {
                                        store.dispatch(setLoading(false));
                                    }, false));
                                }
                                customerInfo.canRemove = false;
                                store.dispatch(setCustomer(customerInfo));
                                riskyItemPromptHandled = true;
                                store.dispatch(closeRightPanelDialogue());
                                store.dispatch({type: START_RFID_READER});
                                store.dispatch(setBlockScannersNormalAction(false));
                            }}
                            onBack={e => {
                                store.dispatch(showRightPanelDialogue(dialogue));
                            }}
                        />
                    )));
                }}
                askForHelp={(supervisor=false) => {
                    let showRiskyItemMessage = (user = false) => {
                        store.dispatch(showDialogue(
                            "riskyItemMessageTitle",
                            "riskyItemMessage",
                            "accept",
                            e => {
                                riskyItemPromptHandled = true;
                                store.dispatch(closeRightPanelDialogue());
                                store.dispatch({type: START_RFID_READER});
                                store.dispatch(setBlockScannersNormalAction(false));
                                if(user !== false){
                                    store.dispatch(setTransactionUser(user));
                                }
                            },
                            e => {},
                            "back",
                            false
                        ));
                    }
                    if(!store.getState().rootReducer.connectionHealth){
                        showRiskyItemMessage();
                        return;
                    }
                    store.dispatch(openLogonModal('', (data) => {
                        let user = data[0];
                        store.dispatch(getUserRights(user.userID, state.rootReducer.pos.pointOfSaleID, (records) => {
                            if( records[0].rightMakeDiscountInPOS === 1 &&
                                (window.AppConf.selfValidateSupervisor || user.userID !== state.rootReducer.user.userID)
                            ){
                                showRiskyItemMessage(user);
                            }else{
                                store.dispatch(addErrorAlert('User has no right to perform this action!'));
                            }
                            return {
                                type: 'USER_RIGHTS_SUCCESS'
                            }
                        }, () => {
                            return addErrorAlert('Could not get user right records, please try again!');
                        }));
                    }, true, supervisor));
                }}
                onClose={() => {
                    store.dispatch({type: START_RFID_READER});
                    store.dispatch(setBlockScannersNormalAction(false));
                }}
            />
        );
        store.dispatch(showRightPanelDialogue(dialogue));
    }else{
        store.dispatch(setCustomerCanRemove(false));
    }
}

const handleEPCProductApiSearch = (store) => {
    let state = store.getState();
    let productCodes = state.rootReducer.productsInBasket.reduce((acc, product) => {
        if((product?.barcode ?? false) !== false && product.barcode !== product.data.code){
            acc.push(product.barcode);
        }
        return acc;
    }, []);
    console.log("EPCProductApiSearch", {productCodes});
    if(productCodes.length > 0){
        store.dispatch(getProductsByCodeFromPim(productCodes, (response) => {
            console.log("EPCProductApiSearch response", response);
            let pimProductByCode = response.reduce((acc, el) => {
                acc[el.code] = el;
                return acc;
            }, {});
            state.rootReducer.productsInBasket.forEach((product) => {
                if((product?.barcode ?? false) !== false && typeof pimProductByCode[product.barcode] !== "undefined"){
                    let pimProduct = pimProductByCode[product.barcode];
                    if(pimProduct.id !== product.data.productID){
                        store.dispatch(findProducts({productIDs: pimProduct.id, recordsOnPage: 1}, state.rootReducer.warehouse.warehouseID, state.rootReducer.posID, result => {
                            let erplyProduct = result[0];
                            let productDTO = new Product(erplyProduct.name, erplyProduct.priceListPrice, erplyProduct.priceListPriceWithVat, product.amount, erplyProduct);
                            productDTO.lineNumber = product.lineNumber;
                            productDTO.barcode = product.barcode;
                            productDTO.data.RFIDTag = product.data.RFIDTag;
                            if(productDTO.data?.isUsedProduct === 1){
                                productDTO.calculateUsedProductPrices();
                            }
                            store.dispatch(saveDecathlonSCOIntegrationLog('info', 'EPC product updated from PIM', {code: 'EPC_PIM_UPDATE', epc: product.barcode}));
                            setTimeout(() => {
                                handleProductAttributesUpdate(store, state, cloneProduct(product), productDTO);
                            }, 1);
                            return updateProduct(productDTO);
                        }, result => {
                            return addErrorAlert('Could not get product info from API');
                        }));
                    }
                }
            });
        }, (response) => {
            console.log("EPCProductApiSearch failed", response);
        }));
    }
}

const handleBlockedItem = (store, state, product, onDone=()=>{}) => {
    if(product.amount >= 0){
        store.dispatch(showDialogue('Item is not authorized for sale!', product.data.code + ' ' + product.name, 'Ok', function () {
            store.dispatch(removeProduct(product));
        }, undefined, undefined, false, 'remove_blocked_' + product.lineNumber));
        onDone();
        return true;
    }else{
        if(product.returnReasonID !== getDefectiveItemReturnReason(state.rootReducer.reasonCodes).reasonID){
            store.dispatch(showDialogue('Item is not authorized for return!', product.data.code + ' ' + product.name, 'Ok', function () {
                store.dispatch(removeProduct(product));
            }, undefined, undefined, false));
            onDone();
            return true;
        }
    }
}

const handleSecurityItem = (store, state, product) => {
    store.dispatch(securityItemAdded());
    if(state.rootReducer.customerAgeVerified === -1){
        store.dispatch(showCallAssistance('securityItem', 'Security item', true, () => {
            store.dispatch(removeProduct(product));
        }, true));
    }else if(state.rootReducer.customerAgeVerified === 0){
        store.dispatch(showDialogue('Item is not authorized for sale!', '', 'Ok', function () {
            let securityItems = getSecurityItems(getProductsInBasket(state));
            for(let product of securityItems){
                store.dispatch(removeProduct(product));
            }
        }, undefined, undefined, false));
        return true;
    }
}

const handleProductAttributesUpdate = (store, state, oldProduct, newProduct) => {
    if(oldProduct.isBlocked()){
        store.dispatch(closeDialogue('remove_blocked_' + oldProduct.lineNumber));
    }
    if(newProduct.isBlocked()){
        handleBlockedItem(store, state, newProduct);
    }
    if(newProduct.isSecurityItem()){
        handleSecurityItem(store, state, newProduct);
    }
    if(oldProduct.isRiskyItem()){
        if(!newProduct.isRiskyItem()){
            store.dispatch(closeRightPanelDialogue());
        }
    }else{
        if(newProduct.isRiskyItem()){
            riskyItemPrompt(store, state);
        }
    }

}

export default actionsMiddleware;
